module.exports = __webpack_public_path__ + "img/apple-app-store.ba1b9975.svg";